module.exports = __webpack_public_path__ + "static/media/cart-product-2.fb8d3ff9.png";